export const shipmentDetailCardPt = {
  root: {
    class:
      '!rounded-lg !border !border-neutral-200 !bg-white !shadow-none',
  },
  body: { class: '!p-4' },
  content: { class: '!p-0' },
};
